exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-wrap {\n    margin-top: -30px;\n    padding-bottom: 50px;\n    /* background-color:#000; */\n    min-height: 670px;    \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_fdb7fa8d/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main